import parse from 'date-fns/parse';
import format from 'date-fns/format';
import isDate from 'date-fns/isValid';
import isEqual from 'date-fns/isEqual';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';

import collectionSearch from 'utilities/collectionSearch';

const SEARCH_KEYS = ['checkNumber', 'projectTitle', 'effective', 'weekEnding'];

const formatDate = d => (isDate(d) ? format(d, 'MMMM do, yyyy') : '');

const parseWeekEnding = value => {
  const dates = [];
  const values = value.split(',');
  values.forEach(date =>
    dates.push(formatDate(parse(date, 'MM/dd/yyyy', new Date()))),
  );
  if (dates.length > 5) {
    return `${dates.slice(0, 5).join(', ')}...`;
  }
  return dates.join(', ');
};

const parseWork = value => (value.split(',').length > 1 ? 'Multiple' : value);

export default (data, filters) => {
  const { search: searchText, from, to } = filters;

  const collection = data
    .map(paystub => {
      const effective = parse(paystub.effectiveDate, 'MM/dd/yyyy', new Date());
      const weekEnding = parseWeekEnding(paystub.weekEndingDate);
      const workState = parseWork(paystub.workState || '');
      const workCountry = parseWork(paystub.workCountry || 'US');
      const date = d => d?.getTime?.() || null;
      const dateParse = d => date(parse(d, 'MM/dd/yyyy', new Date()));
      return {
        ...paystub,
        effectiveDate: date(effective),
        weekEndingDate: dateParse(paystub.weekEndingDate.split(',')[0]),
        effective: formatDate(effective),
        weekEnding,
        workState,
        workCountry,
      };
    })
    .filter(paystub => {
      const date = new Date(paystub.effectiveDate);
      if (from && to) {
        const fromDate = startOfDay(from);
        const toDate = endOfDay(to);
        return (
          (isAfter(date, fromDate) || isEqual(date, fromDate)) &&
          (isBefore(date, toDate) || isEqual(date, toDate))
        );
      }
      if (from) {
        const fromDate = startOfDay(from);
        return isAfter(date, fromDate) || isEqual(date, fromDate);
      }
      if (to) {
        const toDate = endOfDay(to);
        return isBefore(date, toDate) || isEqual(date, toDate);
      }
      return true;
    });

  if (filters.search.length < 2) return collection;
  return collectionSearch({ collection, searchText, searchKeys: SEARCH_KEYS });
};
